module.exports = __webpack_public_path__ + "static/media/plaquette_commerciale_assurance_autonomie.661edbcc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/aa/documents/common/plaquette_commerciale_assurance_autonomie.pdf
// module id = 821
// module chunks = 40